import { CommonModule } from '@angular/common';
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-input-multi-tag',
  standalone: true,
  imports: [
    CommonModule,
    MatChipsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDatepickerModule,
    MatButtonModule,
    MatInputModule,
    MatChipsModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatProgressSpinnerModule,
  ],
  providers: [InputMultiTagComponent],
  templateUrl: './input-multi-tag.component.html',
  styleUrls: ['./input-multi-tag.component.scss']
})
export class InputMultiTagComponent {
  @ViewChild('multiInput') public multiInput!: ElementRef;
  public rule: any;
  public field: any;
  public placeholder: any;
  public type: any;
  public currentRuleValue: any[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  public selectedDate: any; // New property to track selected date
  public isLoading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<InputMultiTagComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputMultiTagComponent,
  ) { }

  ngOnInit() {
    console.log(`=== INPUT MULTI TAG INIT DEBUG ===`);
    if (this.data) {
      console.log('Data received:', this.data);
      console.log('Rule value received:', this.data?.rule?.value);
      console.log('Rule value type:', typeof this.data?.rule?.value);
      console.log('Rule value is array:', Array.isArray(this.data?.rule?.value));
      console.log('Rule value length:', this.data?.rule?.value?.length);
      
      if (this.data?.field?.type === 'date' && Array.isArray(this.data?.rule?.value) && this.data?.rule?.value.length > 0) {
        this.data.rule.value = this.convertDateFormat(this.data?.rule?.value, false);
      }
      this.rule = this.data.rule;
      
      // Force clear currentRuleValue properly
      this.currentRuleValue = [];
      console.log('Initial currentRuleValue set to empty array');
      
      // Ensure proper clearing of currentRuleValue
      if (Array.isArray(this.data?.rule?.value)) {
        if (this.data?.rule?.value.length === 0) {
          console.log('Setting currentRuleValue to empty array (received empty array)');
          this.currentRuleValue = [];
        } else {
          console.log('Setting currentRuleValue to received array:', this.data?.rule?.value);
          this.currentRuleValue = [...this.data?.rule?.value];
        }
      } else {
        console.log('Setting currentRuleValue to empty (not an array)');
        this.currentRuleValue = [];
      }
      
      this.type = this.data?.field?.type;
      this.placeholder = this.type !== 'date' ? `Type ${this.type} then press enter...` : 'MM/DD/YYYY';
      
      console.log('Final currentRuleValue:', this.currentRuleValue);
      console.log('Final currentRuleValue length:', this.currentRuleValue.length);
      console.log(`=== END INPUT MULTI TAG INIT DEBUG ===`);
    }
  }

  public convertDateFormat(dates: string[], toISO: boolean = true): string[] {
    return dates.map((dateStr: string) => {
      if (toISO) {
        // Convert from MM/DD/YYYY to ISO
        const [month, day, year] = dateStr.split('/').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day));
        return date.toISOString();
      } else {
        // Convert from ISO to MM/DD/YYYY
        const date = new Date(dateStr);
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Pad month with leading zero
        const day = ('0' + date.getDate()).slice(-2); // Pad day with leading zero
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      }
    });
  }


  public handleValue(event: any) {
    if (this.type === 'string') {
      const value = event.target.value;
      const regex = /^".*"$/;
      const stringValue = regex.test(value);
      this.separatorKeysCodes = value.includes('"') && !stringValue && value !== '' ? [ENTER] : [ENTER, COMMA];
      if (stringValue) {
        const event: any = { value: value };
        this.add(event, this.type);
      }
    }
  }

  /**
   * Handle this function for adding the mulit tags single input
   * @param event MatChipInputEvent
   * @param rule any
   * @param type string
   */
  public add(event: MatChipInputEvent, type: string): void {
    let value: any = type !== 'date' ? (event.value || '').trim() : event.value;
    if (value === '' && typeof value !== 'number') return;

    this.isLoading = true;

    setTimeout(() => {
      const valueType = typeof value;
      value = valueType !== 'object' ? type === 'date' && value.includes(' ') ? value.split(" ") : value.includes('\n') ? value.split('\n') : value.includes('"') ? value : value.includes(',') ? value.replace(/"/g, '').split(',') : value : value;
      value = valueType !== 'object' && type === 'date' && Array.isArray(value) ? value?.map((item: string) => item.replace(/,$/, '').trim()) : value;
      const itemType = Array.isArray(value);
      const matchNumbers = /^-?\d*\.?\d+$/;
      const matchDate = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
      value = itemType ? value.map((el: string) => el.trim()).filter((el: string) => el !== '') : value;
      value = itemType ? [...new Set(value)] : value;

      if (['string', 'LOOKUP'].includes(type) && value !== '') {
        const valuesArray = itemType ? value : [value];
        if (valuesArray.length > 0) {
          const existingSet = new Set(this.currentRuleValue);
          for (let i = 0; i < valuesArray.length; i++) {
            const item = valuesArray[i].trim();
            if (item && !existingSet.has(item)) {
              existingSet.add(item);
              this.currentRuleValue.push(item);
            }
          }
        }
      }

      if (type === 'number') {
        const valuesArray = itemType ? value : value.includes(' ') ? value.split(' ') : [value];
        if (valuesArray.length > 0) {
          const existingSet = new Set(this.currentRuleValue);
          for (let i = 0; i < valuesArray.length; i++) {
            const item = valuesArray[i].trim();
            const match = matchNumbers.test(item);
            if (match && !existingSet.has(item)) {
              existingSet.add(item);
              this.currentRuleValue.push(item);
            }
          }
        }
      }

      if (type === 'date') {
        const valuesArray = itemType ? value : [value];
        const existingSet = new Set(this.currentRuleValue);
        valuesArray.forEach((val: string) => {
          if (val !== '' && matchDate.test(val)) {
            val = val.trim();
            const parsedDate = new Date(val);
            const isValidDate = !isNaN(parsedDate.getTime()) && this.isValidFormatDate(parsedDate);
            if (isValidDate) {
              const formattedDate = this.formatDateMMDDYYYY(parsedDate);
              if (!existingSet.has(formattedDate)) {
                existingSet.add(formattedDate);
                this.currentRuleValue.push(formattedDate);
              }
            } else {
              console.error('Invalid date input');
            }
          }
        });
      }

      // Keep the user restriction to 10000 directly.
      if (['string', 'number', 'date'].includes(type) && this.currentRuleValue && this.currentRuleValue.length > 10000) {
        console.log(`Truncating array from ${this.currentRuleValue.length} to 10000 items`);
        this.currentRuleValue = this.currentRuleValue.slice(0, 10000);
      }

      // Clear the input value
      if (event && event.chipInput) {
        event.chipInput.clear();
      }
      if (this.multiInput && this.multiInput.nativeElement) {
        this.multiInput.nativeElement.value = '';
      }

      this.isLoading = false;
    }, 10);
  }

  /**
   * Handle this function for remove the multi tag values
   * @param item any
   * @param rule any
   */
  public remove(item: any): void {
    const index = this.currentRuleValue?.findIndex((el: any) => el === item);

    if (index !== -1) {
      this.currentRuleValue?.splice(index, 1);
    }
  }

  /**
   * Handle this function for edit the multi tag values
   * @param item any
   * @param rule any
   * @param event MatChipEditedEvent
   */
  public edit(item: any, rule: any, event: MatChipEditedEvent) {
    let value: any = event.value.trim();
    const currenValIndex = this.currentRuleValue?.findIndex((elm: any) => elm === item);
    let updatedValue = this.currentRuleValue?.includes(value) ? item : value;
    if (rule?.type === 'date') {
      value = this.formatDateMMDDYYYY(value);
      updatedValue = this.currentRuleValue?.includes(value) ? item : value;
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime()) && this.isValidFormatDate(parsedDate)) {
        this.currentRuleValue[currenValIndex] = updatedValue;
      }
    } else {
      this.currentRuleValue[currenValIndex] = updatedValue;
    }
  }

  // Function to check if the date is realistically within range
  public isValidFormatDate(date: Date): boolean {
    // Check for reasonable year range, for example between 1900 and 2100
    const year = date.getFullYear();
    return year >= 1900 && year <= 2100;
  }

  // Function to format a date as MM/DD/YYYY
  public formatDateMMDDYYYY(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');  // getMonth() is zero-based
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${month}/${day}/${year}`;
  }

  public onSubmit() {
    this.rule.value = this.type === 'number' ? this.currentRuleValue.map(Number) : this.currentRuleValue;
    this.dialogRef.close({ event: "Update", data: this.rule });
  }

  public onCancel() {
    this.dialogRef.close(null);
  }

}
